export default function CCreateFunction() {
  return <h2>C Create Function</h2>;
}
